module.exports = __webpack_public_path__ + "img/vendor_logo8.2b6e6594.png";